import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { ConceptBadge } from "@/components/common/ConceptBadge";
import { ArrowUpRight } from "@/icons";
import type { CaseStudy } from "@/types/content";
import { ProjectPreview } from "./ProjectPreview";

/** Layered browser/phone concept mockup, tinted per project. */
// function ProjectMockup({ accent }: { accent: string }) {
//   return (
//     <div className="relative h-52 overflow-hidden rounded-t-[1.25rem]">
//       <div
//         className="absolute inset-0"
//         style={{ background: `linear-gradient(135deg, ${accent}22, ${accent}05)` }}
//       />
//       <div className="absolute inset-0 bg-grid opacity-40" />
//       <div className="absolute left-8 right-8 top-8 overflow-hidden rounded-t-xl border border-border bg-card shadow-[0_24px_60px_-30px_rgba(15,23,42,0.4)]">
//         <div className="flex items-center gap-1.5 border-b border-border bg-background/70 px-3 py-2">
//           <span className="h-2 w-2 rounded-full" style={{ background: accent }} />
//           <span className="h-2 w-2 rounded-full bg-muted-foreground/30" />
//           <span className="h-2 w-2 rounded-full bg-muted-foreground/30" />
//         </div>
//         <div className="space-y-2 p-4">
//           <div className="h-3 w-1/3 rounded-full" style={{ background: `${accent}88` }} />
//           <div className="h-2 w-3/4 rounded-full bg-muted" />
//           <div className="mt-3 grid grid-cols-3 gap-2">
//             {[0, 1, 2].map((i) => (
//               <div key={i} className="h-10 rounded-lg bg-muted" />
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

/** Reusable portfolio/case-study card. */
export function ProjectCard({ project }: { project: CaseStudy }) {
  return (
    <article
      data-testid={`portfolio-card-${project.slug}`}
      className="group flex h-full flex-col overflow-hidden rounded-[1.25rem] border border-border bg-card transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_30px_70px_-32px_rgba(15,23,42,0.3)]"
    >
      <div className="relative">
        {/* <ProjectMockup accent={project.accent} /> */}
        {/* added sudip */}
        <ProjectPreview industry={project.industry} accent={project.accent} />
        <div className="absolute right-4 top-4">
          <ConceptBadge accent={project.accent} />
        </div>
      </div>
      <div className="relative">

        <div
          className="absolute inset-0"
          style={{ background: `linear-gradient(135deg, ${project.accent}22, ${project.accent}08)`, }}
        />

        <div className="absolute inset-0 bg-grid opacity-40" />

        <div className="flex flex-1 flex-col relative my-5 mx-5 rounded-2xl border border-border bg-card p-6 shadow-sm">

          {/* Category */}

          <div className="flex items-center justify-between">

            <div className="flex flex-wrap gap-2">

              <Badge
                // variant="secondary"
                className="rounded-full border-0 text-white"
                style={{ backgroundColor: project.accent, }}
              >
                {project.industry}
              </Badge>

              <Badge
                // variant="outline"
                className="rounded-full"
                style={{ color: project.accent, borderColor: project.accent, backgroundColor: `${project.accent}12`, }}
              >
                {project.category}
              </Badge>

            </div>

          </div>

          {/* Title */}

          <div 
            className="group" 
             style={
                {
                  "--accent": project.accent,
                } as React.CSSProperties
              }
          >
            <h3 className="mt-4 font-heading text-2xl font-bold leading-tight text-foreground transition-colors group-hover:text-[var(--accent)]">
              {project.title}
            </h3>
          </div>
          {/* <h3
            className="mt-4 font-heading text-2xl font-bold leading-tight text-foreground transition-colors group-hover:text-primary" >
            {project.title}
          </h3> */}

          {/* Summary */}

          <p className="mt-3 text-sm leading-7 text-muted-foreground">
            {project.cardSummary}
          </p>

          {/* Business Outcome */}

          {/* <div className="mt-6 flex items-start gap-3" > */}
          <div className="mt-5 rounded-xl border border-border bg-muted/40 p-4" >

            <div className="text-center text-xs font-bold uppercase tracking-wider text-muted-foreground" >
              Business Outcome
            </div>

            <div className="mt-2 text-sm font-medium" style={{ color: project.accent, }} >
              {project.businessOutcome}
            </div>

          </div>

          {/* Technologies */}

          <div className="mt-5 flex flex-wrap gap-2" >

            {project.tech
              .slice(0, 3)
              .map((tech) => (

                <Badge
                  key={tech}
                  variant="secondary"
                  className="rounded-full"
                >
                  {tech}
                </Badge>

              ))}

            {project.tech.length > 3 && (

              <Badge variant="outline" className="rounded-full" >
                +{project.tech.length - 3}
              </Badge>

            )}

          </div>

          {/* CTA */}

          <Link

            to={`/case-studies/${project.slug}`}

            data-testid={`portfolio-link-${project.slug}`}

            className="mt-6 inline-flex items-center gap-2 font-semibold text-primary transition-all duration-300 group-hover:gap-3" >

            Explore Case Study

            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />

          </Link>

        </div>
      </div>
      {/* <div className="flex flex-1 flex-col p-7">
        <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.14em] text-accent">
          <span>{project.category}</span>
          <span className="h-1 w-1 rounded-full bg-muted-foreground/40" />
          <span className="text-muted-foreground">{project.industry}</span>
        </div>
        <h3 className="mt-2 font-heading text-2xl font-bold text-foreground">
          {project.title}
        </h3>
        <p className="mt-2.5 flex-1 text-sm leading-relaxed text-muted-foreground">
          {project.summary}
        </p>
        <div className="mt-5 flex flex-wrap gap-2">
          {project.tech.slice(0, 4).map((t) => (
            <Badge
              key={t}
              variant="secondary"
              className="rounded-full bg-muted font-medium text-muted-foreground"
            >
              {t}
            </Badge>
          ))}
        </div>
        <Link
          to={`/case-studies/${project.slug}`}
          data-testid={`portfolio-link-${project.slug}`}
          className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-primary transition-all duration-300 group-hover:gap-2.5"
        >
          View Case Study <ArrowUpRight className="h-4 w-4" />
        </Link>
      </div> */}
    </article>
  );
}
